import React, { useState } from 'react';
import { createWorker } from 'tesseract.js';
import './App.css';
import preprocessImage from './preprocess';

function App() {
  const [source, setSource] = useState('');
  const [text, setText] = useState('Please upload image');
  const [progress, setProgress] = useState(0);

  const handleChange = (event) => {
    if (event.target.files.length !== 0) {
      let image = URL.createObjectURL(event.target.files[0]);
      setSource(image);
    }
    setText('Image ready to be process');
  };



  const handleClick = async () => {
    setText('loading');
    setProgress(0);
    try {
      const worker = await createWorker('eng', 1, {
        logger: (m) => {
          console.log(m);
          if (m.status === 'recognizing text') {
            setProgress(parseInt(m.progress * 100, 10));
          }
        },
      });

      setText('Engine initialised working on recognising');

      let imageToRecognize = source;
      const img = document.querySelector('img[alt="capturedimg"]');
      const canvas = document.getElementById('preview');
      if (img && canvas) {
        if (img.complete && img.naturalHeight !== 0) {
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          preprocessImage(canvas);
          imageToRecognize = canvas;
        }
      }

      const {
        data: { text },
      } = await worker.recognize(imageToRecognize);
      await worker.terminate();
      setText(text);
    } catch (err) {
      setText(`error: ${err.message || err}`);
    }
  };

  return (
    <div className='App'>
      <h3>Image to text</h3>
      <p>
        Take a photo or upload a image then click 'Convert to Text' to get text
      </p>
      <div>
        <input
          accept='image/*'
          type='file'
          capture='environment'
          onChange={handleChange}
        />
      </div>
      {/* <button onClick={handleProcessImage}>Process Image</button> */}
      {text !== 'Image ready to be process' ? (
        <button onClick={handleClick} disabled>
          Convert to Text
        </button>
      ) : (
        <button onClick={handleClick}>Convert to Text</button>
      )}
      <h3>Extracted text</h3>
      <div className='text-box'>
        <p> {text} </p>

        {/* progress bar */}
        {progress < 100 && progress > 0 && <div>Progress {progress}%</div>}
      </div>
      <br />
      {source && (
        <img src={source} alt='capturedimg' style={{ maxWidth: '100%' }} />
      )}
      <canvas id='preview' className='preview m-auto'></canvas>
    </div>
  );
}

export default App;
